export default __webpack_public_path__ + "static/media/Gwent-YPMod3-InCourseWorkbook.d4376008.pdf";